import { styled } from '@mui/system';
import { Typography, Box, Grid2, Link } from '@mui/material';

export const LinkStyled = styled(Link)({
  color: '#002A3A',
  fontSize: '1.625rem',
  fontWeight: 450,
  fontFamily: 'BrandonGrotesqueRegular',
  textDecoration: 'none',
  '&:hover': {
    background: '#004F71',
    p: {
      color: '#fff'
    }
  },
  '&:active': {
    border: '0.125rem solid #004F71',
    background: 'transparent',
    p: {
      color: '#004F71'
    }
  }
});

export const TypographyStyledHeader = styled(Typography)({
  color: '#004F71',
  fontSize: '56px',
  fontWeight: 450,
  fontFamily: 'BGBold'
});

export const TypographyStyledBlack = styled(Typography)({
  color: '#000000',
  fontSize: '1.125rem',
  fontWeight: 420,
  '&:hover': { cursor: 'pointer' }
});

export const BoxRowStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '100px'
});

export const GridColStyled = styled(Grid2)({
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});

export const GridRowStyled = styled(Grid2)({
  display: 'flex',
  flexDirection: 'row',
  paddingBlock: '0.625rem',
  width: '100%'
});
